export default __webpack_public_path__ + "static/media/trippin7.19efc414.jpg";